import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { useOpponentVideoItem } from '@gem/call/CallView/hooks/useOpponentVideoItem/useOpponentVideoItem';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

import { OpponentVideo } from '../../../OpponentVideo/OpponentVideo';
import styles from './OpponentVideoItem.styles.m.css';

interface IOpponentVideoItemProps {
  avatarType: AvatarTypes;
  opponentUid: ProviderUid;
}

export const OpponentVideoItem: FC<IOpponentVideoItemProps> = observer(
  ({ avatarType, opponentUid }) => {
    const { opponent, opponentPosition, onOpponentClick } = useOpponentVideoItem(opponentUid, true);

    if (!opponent) {
      return null;
    }

    return (
      <OpponentVideo
        isHighlightAudio
        opponent={opponent}
        opponentPosition={opponentPosition}
        containerClassName={styles.videoContainer}
        avatarType={avatarType}
        className={styles.video}
        onClick={onOpponentClick}
      />
    );
  }
);
